import { IEquatable } from './entity';

export enum RedirectReason {
  MovedPermanently = '301',
  Found = '302',
  TemporaryRedirect = '307',
  PermanentRedirect = '308',
  Gone = '410',
}

export type IRedirect = {
  id: IEquatable;
  status: RedirectReason;
  from: string;
  to?: string;
  name?: string;
  order?: number;
  isActive: boolean;
};
